module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-equ-5f05468c1d16c0fb4b020ec263f5fee5.png";